<template>
  <div class="iframe-block betDetail" v-show="betDetailURL !== null">
    <iframe scrolling="no" frameborder="0" :src="betDetailURL"></iframe>
    <div v-if="showCloseBtn" class="close-iframe-btn" @click="closeBetDetailIframe"></div>
  </div>
</template>

<script>
import Base from '@/mixins/base'
import { mapState } from 'vuex'
import * as _ from 'lodash'

export default {
  name: 'BetDetailIframe',
  props: {},
  data() {
    return {
      // 是否顯示關閉按鈕
      showCloseBtn: true
    }
  },
  mixins: [
    Base
  ],
  computed: {
    ...mapState({
      betDetailURL: state => state.url.betDetailURL
    }),
  },
  watch: {},
  components: {},
  created() {},
  mounted() {
    this.getMessage()
  },
  beforeDestroy() {
    this.removeMessage()
  },
  methods: {
    /**
     * 關閉下注記錄iframe
     */
    closeBetDetailIframe() {
      this.$store.dispatch('url/resetBetDetail')
    },
    getMessage() {
      // 接收 close 按鈕顯示與否 postMessage
      const self = this
      window.addEventListener('message', function(event) {
        let eventData;
        try {
          eventData = _.isString(event.data) ? JSON.parse(event.data) : event.data
          const method = eventData.method || false
          if (method !== 'closeBtnShown' && method !== 'closeBtnHidden') return
          console.log('lobby get message:', event)
          self.showCloseBtn = method === 'closeBtnShown'
        } catch(e) {
          console.warn("JSON parse failed", e);
        }
      })
    },
    removeMessage() {
      window.removeEventListener('message', null)
    }
  }
}
</script>
<style lang="scss" src="@/assets/css/app.scss"></style>
